<template>
  <div class="pwc-event-register">
    <v-layout row class="pwc-register-row">
      <v-flex md6 hidden-xs-and-down class="pwc-register-image">
        <v-img height="100%" :src="cRandomBgUrl" aspect-ratio="1.7" />
      </v-flex>
      <v-flex md4 sm6 offset-md1 xs12 class="pwc-register-form" d-flex>
        <v-layout class="pwc-register-logo">
          <v-flex>
            <v-img :src="cLogo" style="width:230px; margin:auto;" />
          </v-flex>
        </v-layout>
        <v-layout row class="pwc-form-phone">
          <v-flex sm3 xs3>
            <v-select
              v-model="code"
              item-text="code"
              item-value="code"
              single-line
              label="Code"
              style="margin-right:6px"
              :items="cCountryCode"
            >
              <template v-slot:item="{ item }">
                <div style="width:190px; display: flex; justify-content: space-between;">
                  <div>{{ item.name }}</div>
                  <div>{{ item.code }}</div>
                </div>
              </template>
            </v-select>
          </v-flex>
          <v-flex sm20 xs20>
            <v-text-field
              ref="phone"
              key="Phone"
              v-model="phone"
              mask="##############"
              :validate-on-blur="true"
              :rules="[rules.required, ()=> {return rules.phone(phone, code) }]"
              single-line
              label="手机号码"
              required
            />
          </v-flex>
        </v-layout>
        <v-layout row class="pwc-form-code">
          <v-flex>
            <v-text-field
              ref="verifyCode"
              key="verifyCode"
              v-model="verifyCode"
              mask="######"
              :validate-on-blur="true"
              single-line
              label="验证码"
              required
              :rules="[rules.required, rules.verifyCode]"
            />
          </v-flex>
          <v-btn
            color="#d04a02"
            outline
            :disabled="cVerifyDisabled"
            @click="handleVerify"
          >{{ cVerifyButtonText }}</v-btn>
        </v-layout>
        <v-layout row class="pwc-form-privacy">
          <v-checkbox v-model="privacyAgree" style="margin-top:0;" color="#d04a02">
            <span slot="label">我了解并接受
              <a href="https://youplusapplication.businesstrainingshpwc.com/application/TermsOfUse.html">&nbsp;使用条款&nbsp;</a>和
              <a href="https://youplusapplication.businesstrainingshpwc.com/application/PrivacyStatement.html">&nbsp;隐私条款</a></span>
          </v-checkbox>
        </v-layout>
        <v-layout row class="pwc-form-action">
          <v-flex xs12>
            <v-btn
              block
              color="#d04a02"
              :disabled="disableLogin"
              @click="handleLogin"
            >确定</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog v-model="cLoading" persistent light width="120px">
      <v-card
        style="
        height: 120px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.7);
      "
      >
        <v-progress-circular indeterminate color="#fff" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { validRequired, validEmail, validCode, validPhone } from '@/util/validation'
import CountryCode from '@/config/countryCode'
import { next } from '@/mixin/index'
import logo from '@/assets/logo.png'
import { logic } from '../common/mixin/logic'

// image
import img_0 from '@/assets/event-bg-0.jpg'
import img_1 from '@/assets/event-bg-1.jpg'
import img_2 from '@/assets/event-bg-2.jpg'
import img_3 from '@/assets/event-bg-3.jpg'

const InitCountdown = 60
// const UserType = {
//   NewUser: 0,
//   UserNotRegistered: 1,
//   UserRegistered: 2
// }

export default {
  mixins: [next, logic],
  data() {
    return {
      dialog: false,
      dialogText: '',
      code: 86,
      phone: '',
      verifyCode: '',
      rules: {
        required: validRequired,
        email: validEmail,
        phone: validPhone,
        verifyCode: validCode
      },

      disableLogin: true,
      disableVerify: true,
      // loading: false,

      countdown: InitCountdown,
      privacyAgree: false
    }
  },
  computed: {
    cRandomBgUrl() {
      const imgList = [img_0, img_1, img_2, img_3]
      return imgList[Date.now() % 4]
    },
    cLogo() {
      return logo
    },
    cCountryCode() {
      return CountryCode
    },
    cVerifyButtonText() {
      if (this.countdown === InitCountdown) {
        return '获取验证码'
      }
      return `${this.countdown}s后重试`
    },
    cVerifyDisabled() {
      return this.countdown !== InitCountdown || this.disableVerify
    }
  },
  methods: {
    handleCheck() {
      if (
        this.code &&
        this.phone &&
        validPhone(this.phone, this.code) === true
      ) {
        this.disableVerify = false
      } else {
        this.disableVerify = true
      }

      if (
        this.code &&
        this.phone &&
        this.verifyCode &&
        validPhone(this.phone, this.code) === true &&
        validCode(this.verifyCode) === true &&
        this.privacyAgree
      ) {
        this.disableLogin = false
      } else {
        this.disableLogin = true
      }
    },
    showDialogInfo(message) {
      if (message) {
        this.dialogText = message
        this.dialog = true
      }
    },
    // showLoading() {
    //   this.loading = true
    // },
    // closeLoading() {
    //   this.loading = false
    // },
    handleVerify() {
      const phone = this.rulePhone()
      if (phone) {
        return this.showDialogInfo(phone)
      }
      if (this.countdown !== InitCountdown) {
        return
      }
      this.getVerifyCode({
        contryCode: this.code,
        phoneNo: this.phone
      }).catch(err => {
        this.showDialogInfo('网络错误 ', err)
      })
      this.countdown -= 1
      this.timer = setInterval(() => {
        if (this.countdown === 0) {
          this.countdown = InitCountdown
          return clearInterval(this.timer)
        }
        this.countdown -= 1
      }, 1000)
    },
    handleLogin() {
      const phoneRule = this.rulePhone()
      const verifyCodeRule = this.ruleVerifyCode()
      if (phoneRule || verifyCodeRule) {
        return this.showDialogInfo(phoneRule || verifyCodeRule)
      }
      // this.showLoading()

      this.login({
        contryCode: this.code,
        phoneNo: this.phone,
        campaignId: this.campaignId,
        campaignCode: this.campaignCode,
        verificationCode: this.verifyCode,
        eventId: this.eventId
      })
      // .then(() => {
      //   // const userType = Number(this.userInfo.leadRegisterStatus)
      //   // if (userType === UserType.UserRegistered) {
      //   //   //
      //   // } else if (userType === UserType.UserNotRegistered) {
      //   //   //
      //   // }
      //   this.$router.replace({
      //     name: RouterName.home
      //   })
      // }).catch(err => {
      //   this.showDialogInfo(err)
      // }).finally(() => {
      //   this.closeLoading()
      // })
    },
    // field rule
    rulePhone() {
      if (!this.phone) {
        return '请输入手机号码'
      }
      // only check china
      if (this.code === 86 && !validPhone(this.phone)) {
        return '手机号码格式不合法'
      }
    },
    ruleVerifyCode() {
      if (String(this.verifyCode).length !== 6) {
        return '验证码格式不合法'
      }
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>

<style lang="scss">
.pwc-event-register {
    .v-text-field {
        padding-top: 0;
        margin-top: 0;
    }
    .layout.row {
        width: 100%;
    }
    .pwc-form-code {
        .v-btn__content {
            color: #fb8c00;
        }
        .v-btn--disabled {
            > .v-btn__content {
                color: rgba(0,0,0,0.26);
            }
        }
        .v-btn {
            margin: 0;
            width: 100%;
            max-width: 100px;
            margin-left: 10px;
        }
    }
    .v-btn {
        margin:auto;
        max-width: 230px;
    }
    .v-btn__content {
        color: #fff;
    }
    .pwc-form-privacy {
      i {
        font-size: 14px;
      }
      .v-input--selection-controls__input {
        margin-right: 0;
      }
    }
}
</style>

